type WorkflowExecutionPhase = 'init' | 'running' | 'completed' | 'failed'

type WorkflowLeaveGuardOptions = {
    workflowExecutionPhase?: WorkflowExecutionPhase | string
    allowUnpromptedWorkflowLeave?: boolean
}

export const shouldPromptBeforeWorkflowLeave = ({
    workflowExecutionPhase,
    allowUnpromptedWorkflowLeave,
}: WorkflowLeaveGuardOptions): boolean => {
    return workflowExecutionPhase === 'running' && allowUnpromptedWorkflowLeave === false
}
